export default "__VITE_ASSET__ee4b5568__"